import { Box, Typography } from "@mui/material";
import { colors } from "../../theme/colors";
import { AnimatedView } from "./AnimatedView";
import Button from "./Button";
import NavButton from "./NavButton";

type Props = {
  title: string;
  actionType?: "navigate" | "custom";
  actionLabel: string;
  route?: string;
  action?: () => void;
};

export const BottomActionBar = ({
  title,
  actionType = "navigate",
  actionLabel,
  route,
  action
}: Props) => {
  return (
    <Box
      sx={{
        width: "100%",
        borderRadius: "100% 0% 100% 0% / 0% 80% 10% 100%",
        mb: -10,
        p: { xs: 10, md: 15 },
        backgroundColor: colors.grey1,
        zIndex: 1
      }}>
      <AnimatedView
        animation="popIn"
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          textAlign: "center",
          gap: 5
        }}>
        <Typography variant="h6">{title}</Typography>
        {actionType === "navigate" && route ? (
          <NavButton variant="secondary" label={actionLabel} route={route} />
        ) : (
          <Button variant="secondary" onClick={action} label={actionLabel} />
        )}
      </AnimatedView>
    </Box>
  );
};
